import script from "./BindingSearchPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./BindingSearchPopup.vue?vue&type=script&setup=true&lang=js"

import "./BindingSearchPopup.vue?vue&type=style&index=0&id=275c7566&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-275c7566"]])

export default __exports__